export default {
  "gemGoodsAdmin.thead.index": "#NO",
  "gemGoodsAdmin.thead.documentId": "DocumentId",
  "gemGoodsAdmin.thead.goodsId": "Id",
  "gemGoodsAdmin.thead.goodsName": "商品名称",
  "gemGoodsAdmin.thead.goodsImg": "商品图片",
  "gemGoodsAdmin.thead.gem_goods_type": "商品类型",
  "gemGoodsAdmin.thead.stocks": "库存",
  "gemGoodsAdmin.thead.activeState": "状态",
  "gemGoodsAdmin.thead.createdAt": "创建时间",
  "gemGoodsAdmin.thead.updatedAt": "更新新时间",

  "gemGoodsAdmin.add": "新增",
  "gemGoodsAdmin.edit": "编辑",
  "gemGoodsAdmin.details": "详情",
  "gemGoodsAdmin.delete": "删除",
  "gemGoodsAdmin.thead.action": "操作",
};
